import React from 'react';
import { ShieldAlert, Users, Heart, FileCheck, AlertTriangle, Building2 } from 'lucide-react';
import { problemi } from '../mockData';

const iconMap = {
  ShieldAlert,
  Users,
  Heart,
  FileCheck,
  AlertTriangle,
  Building2
};

const ProblemaSection = () => {
  return (
    <section id="problema" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-block px-4 py-2 bg-[#E74C3C]/10 text-[#E74C3C] rounded-full text-sm font-semibold mb-4">
            Le Criticità da Affrontare
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#1B2380] mb-6">
            Stai correndo rischi{' '}
            <span className="text-[#E74C3C]">inconsapevoli</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Gli Enti del Terzo Settore e le Cooperative affrontano sfide assicurative uniche 
            che le polizze standard non possono coprire adeguatamente.
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {problemi.map((problema, index) => {
            const IconComponent = iconMap[problema.icona];
            return (
              <div
                key={index}
                className="group bg-white rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-14 h-14 bg-gradient-to-br from-[#E74C3C]/10 to-[#E67E22]/10 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <IconComponent className="text-[#E74C3C]" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#1B2380] transition-colors duration-300">
                  {problema.titolo}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {problema.descrizione}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Box */}
        <div className="mt-16 bg-gradient-to-r from-[#1B2380] to-[#0E8C84] rounded-2xl p-8 sm:p-12 text-center shadow-xl animate-fade-in-up">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Non lasciare la tua missione sociale esposta a rischi evitabili
          </h3>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Richiedi una Diagnosi di Sostenibilità Assicurativa gratuita per proteggere chi conta sulla tua organizzazione
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contatti');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white text-[#1B2380] px-8 py-4 rounded-lg font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 inline-block"
          >
            Richiedi Diagnosi Gratuita
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProblemaSection;
